import { EmailLogin } from 'components/auth/EmailLogin';
import { AuthLayout } from 'components/layout/AuthLayout';

export default function SignUpPage() {
  return (
    <AuthLayout>
      <EmailLogin type="signup" />
    </AuthLayout>
  );
}
